import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import Cookies from "js-cookie";
import moment from "moment";
import qs from "qs";

import { AxiosCustomGet } from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import Title from "../../../../components/common/Title/Title";
import ActiveOutlets from "../../components/ActiveOutlets/ActiveOutlets";
import CapitalTransaction from "./components/CapitalTransaction";
import CashTransaction from "./components/CashTransaction";
import ChooseOutletDialog from "../../components/ChooseOutletDialog";
import DetailDialog from "../../components/DetailDialog";
import PreviewImage from "../../../../components/common/PreviewImage/PreviewImage";

import SwalToast from "../../../../components/helpers/SwalToast";
import { convertOutletList } from "../../helpers";
import {
  convertCapitalTransaction,
  convertCashTransaction,
  convertTransactionTypeCount,
} from "./helpers";
import { convertTransactionDetail } from "../pawn_transaction/helpers";

import {
  capitalTransactionTypeList,
  CAPITAL_TYPE,
  cashTransactionTypeList,
  CASH_TYPE,
  initCapitalFilterInput,
  initCashFilterInput,
} from "./constants";

import "../../styles.css";
import { CurrencyFormat } from "../../../../components/helpers";

const TabPane = Tabs.TabPane;

const CapitalCashTransaction = () => {
  const [capitalFilterInput, setCapitalFilterInput] = useState(
    initCapitalFilterInput
  );
  const [capitalTransactionList, setCapitalTransactionList] = useState([]);
  const [capitalTransactionTypeCount, setCapitalTransactionTypeCount] =
    useState(capitalTransactionTypeList);
  const [capitalTablePagination, setCapitalTablePagination] = useState({});
  const [capitalOutletCheckedList, setCapitalOutletCheckedList] = useState([]);
  const [capitalIndeterminate, setCapitalIndeterminate] = useState(false);
  const [capitalOutletCheckAll, setCapitalOutletCheckAll] = useState(false);
  const [capitalDateValue, setCapitalDateValue] = useState([]);
  const [capitalPageSize, setCapitalPageSize] = useState(10);
  const [capitalSearchName, setCapitalSearchName] = useState("");

  const [cashFilterInput, setCashFilterInput] = useState(initCashFilterInput);
  const [cashTransactionList, setCashTransactionList] = useState([]);
  const [cashTransactionTypeCount, setCashTransactionTypeCount] = useState(
    cashTransactionTypeList
  );
  const [cashTablePagination, setCashTablePagination] = useState({});
  const [cashOutletCheckedList, setCashOutletCheckedList] = useState([]);
  const [cashIndeterminate, setCashIndeterminate] = useState(false);
  const [cashOutletCheckAll, setCashOutletCheckAll] = useState(false);
  const [cashDateValue, setCashDateValue] = useState([]);
  const [cashPageSize, setCashPageSize] = useState(10);

  const [tabState, setTabState] = useState(CAPITAL_TYPE);
  const [outletList, setOutletList] = useState([]);
  const [isOutletDialogOpen, setIsOutletDialogOpen] = useState(false);
  const [isDetailDialogOpen, setIsDetailDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isChangingType, setIsChangingType] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState({});
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [imgLink, setImgLink] = useState("");
  const [capitalData, setCapitalData] = useState({});

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletList(convertOutletList(response.data.data));

        const outletListId = response.data.data.map((outlet) => {
          return outlet.id;
        });

        setCapitalOutletCheckedList(outletListId);
        setCapitalIndeterminate(false);
        setCapitalOutletCheckAll(true);

        setCashOutletCheckedList(outletListId);
        setCashIndeterminate(false);
        setCashOutletCheckAll(true);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data outlet: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getCapitalTransactionList = () => {
    setLoading(true);
    const data = {
      query: capitalFilterInput.searchName,
      outlet_id_list: capitalFilterInput.outlets,
      date_start: capitalFilterInput.transactionStartDate,
      date_end: capitalFilterInput.transactionEndDate,
      page: capitalFilterInput.page,
      size: parseInt(capitalFilterInput.pageSize),
      transaction_type: capitalFilterInput.transactionType,
      sorting_field: capitalFilterInput.sortingField,
      sorting_order: capitalFilterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/outlet-capital`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);
        setCapitalTransactionList(
          convertCapitalTransaction(
            response.data.data.items.outlet_capital_transaction_list
          )
        );

        if (!isChangingType) {
          setCapitalTransactionTypeCount(
            convertTransactionTypeCount(
              capitalTransactionTypeList,
              response.data.data.items.transaction_type_count,
              capitalFilterInput.transactionType
            )
          );
        }

        setCapitalTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });

        setIsChangingType(false);
        getCapitalTotalSummary();
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getCashTransactionList = () => {
    setLoading(true);
    const data = {
      outlet_id_list: cashFilterInput.outlets,
      date_start: cashFilterInput.transactionStartDate,
      date_end: cashFilterInput.transactionEndDate,
      page: cashFilterInput.page,
      size: parseInt(cashFilterInput.pageSize),
      transaction_type: cashFilterInput.transactionType,
      sorting_field: cashFilterInput.sortingField,
      sorting_order: cashFilterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/petty-cash`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);
        setCashTransactionList(
          convertCashTransaction(
            response.data.data.items.petty_cash_transaction_list,
            handleOpenPreview
          )
        );

        if (!isChangingType) {
          setCashTransactionTypeCount(
            convertTransactionTypeCount(
              cashTransactionTypeList,
              response.data.data.items.transaction_type_count,
              cashFilterInput.transactionType
            )
          );
        }
        setCashTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });

        setIsChangingType(false);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getTransactionDetail = (transactionID) => {
    const data = {
      transaction_id: transactionID,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/gadai/detail`;

    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data
      ),
      (response) => {
        const detail = convertTransactionDetail(response.data.data);
        setSelectedTransaction(detail);
        setIsDetailDialogOpen(true);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data detail transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;

    if (tabState === CAPITAL_TYPE) {
      if (name === "pageSize") {
        setCapitalPageSize(value);
      } else if (name === "searchName") {
        setCapitalSearchName(value);
      }
    } else {
      setCashPageSize(value);
    }
  };

  const handleEnter =
    (type = "enter") =>
    (event) => {
      const { name, value } = event.target;
      if (event.keyCode === 13 || type === "blur") {
        if (tabState === CAPITAL_TYPE) {
          if (name === "pageSize" && value === "") {
            setCapitalPageSize(10);
          }
          setCapitalFilterInput((prev) => ({
            ...prev,
            [name]: name === "pageSize" && value === "" ? 10 : value,
            page: 1,
          }));
        } else {
          if (name === "pageSize" && value === "") {
            setCashPageSize(10);
          }
          setCashFilterInput((prev) => ({
            ...prev,
            [name]: name === "pageSize" && value === "" ? 10 : value,
            page: 1,
          }));
        }
      }
    };

  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");

    if (tabState === CAPITAL_TYPE) {
      setCapitalDateValue(event ? [startDate, endDate] : null);
      setCapitalFilterInput((prev) => ({
        ...prev,
        transactionStartDate: event ? new Date(startDate) : null,
        transactionEndDate: event ? new Date(endDate) : null,
        page: 1,
      }));
    } else {
      setCashDateValue(event ? [startDate, endDate] : null);
      setCashFilterInput((prev) => ({
        ...prev,
        transactionStartDate: event ? new Date(startDate) : null,
        transactionEndDate: event ? new Date(endDate) : null,
        page: 1,
      }));
    }
  };

  const handleSingleOutletChange = (list) => {
    if (tabState === CAPITAL_TYPE) {
      setCapitalOutletCheckedList(list);
      setCapitalIndeterminate(!!list.length && list.length < outletList.length);
      setCapitalOutletCheckAll(list.length === outletList.length);
    } else {
      setCashOutletCheckedList(list);
      setCashIndeterminate(!!list.length && list.length < outletList.length);
      setCashOutletCheckAll(list.length === outletList.length);
    }
  };

  const handleOutletCheckAllChange = (event) => {
    const outletListId = outletList.map((outlet) => {
      return outlet.value;
    });

    if (tabState === CAPITAL_TYPE) {
      setCapitalOutletCheckedList(event.target.checked ? outletListId : []);
      setCapitalIndeterminate(false);
      setCapitalOutletCheckAll(event.target.checked);
    } else {
      setCashOutletCheckedList(event.target.checked ? outletListId : []);
      setCashIndeterminate(false);
      setCashOutletCheckAll(event.target.checked);
    }
  };

  const handleOutletButtonClick = () => {
    setIsOutletDialogOpen(true);
  };

  const handleOutletSave = () => {
    if (tabState === CAPITAL_TYPE) {
      setCapitalFilterInput((prev) => ({
        ...prev,
        outlets: capitalOutletCheckedList,
        page: 1,
      }));
    } else {
      setCashFilterInput((prev) => ({
        ...prev,
        outlets: cashOutletCheckedList,
        page: 1,
      }));
    }
    setIsOutletDialogOpen(false);
  };

  const handleOutletCancel = () => {
    setSelectedTransaction({});
    setIsDetailDialogOpen(false);
    setIsOutletDialogOpen(false);
  };

  const handlePrintReceipt = () => {
    window.open(
      `/history/capital-cash/print-nota/${selectedTransaction.gadaiID}`,
      "_blank",
      "noopener"
    );
    setIsDetailDialogOpen(false);
  };

  const handleTabChange = (key) => {
    setTabState(key);
  };

  const handleDetailButtonClick = (transactionID) => {
    getTransactionDetail(transactionID);
  };

  const handleReset = () => {
    const outletListId = outletList.map((outlet) => {
      return outlet.value;
    });

    if (tabState === CAPITAL_TYPE) {
      setCapitalOutletCheckedList(outletListId);
      setCapitalIndeterminate(false);
      setCapitalOutletCheckAll(true);
      setCapitalDateValue([]);
      setCapitalPageSize(10);
      setCapitalSearchName("");
      setCapitalFilterInput(initCapitalFilterInput);
    } else {
      setCashOutletCheckedList(outletListId);
      setCashIndeterminate(false);
      setCashOutletCheckAll(true);
      setCashDateValue([]);
      setCashPageSize(10);
      setCashFilterInput(initCashFilterInput);
    }
  };

  const handleTransactionTypeChange = (e) => {
    setIsChangingType(true);
    const currentValue = e.target.value;

    if (tabState === CAPITAL_TYPE) {
      setCapitalTransactionTypeCount((prev) => {
        const temp = [...prev];
        temp.map((transType) => {
          transType.active = currentValue === transType.value ? true : false;
          return transType;
        });
        return temp;
      });

      setCapitalFilterInput((prev) => ({
        ...prev,
        transactionType: currentValue,
        page: 1,
      }));
    } else {
      setCashTransactionTypeCount((prev) => {
        const temp = [...prev];
        temp.map((transType) => {
          transType.active = currentValue === transType.value ? true : false;
          return transType;
        });
        return temp;
      });

      setCashFilterInput((prev) => ({
        ...prev,
        transactionType: currentValue,
        page: 1,
      }));
    }
  };

  const handleTableChange = (pagination, _, sorter) => {
    if (tabState === CAPITAL_TYPE) {
      setCapitalFilterInput((prev) => ({
        ...prev,
        page: pagination.current,
        pageSize: parseInt(pagination.pageSize),
        sortingField: sorter?.column?.backend_key || null,
        sortingOrder:
          sorter?.order === "ascend"
            ? "ASC"
            : sorter?.order === "descend"
            ? "DESC"
            : null,
      }));
    } else {
      setCashFilterInput((prev) => ({
        ...prev,
        page: pagination.current,
        pageSize: parseInt(pagination.pageSize),
        sortingField: sorter?.column?.backend_key || null,
        sortingOrder:
          sorter?.order === "ascend"
            ? "ASC"
            : sorter?.order === "descend"
            ? "DESC"
            : null,
      }));
    }
  };

  const handleExport = (type) => (e) => {
    if (type === "excel") {
      handleExportExcel();
    }
  };

  const handleExportExcel = () => {
    let data = {};
    let filename = "";
    let url = "";

    if (tabState === CAPITAL_TYPE) {
      data = {
        query: capitalFilterInput.searchName,
        outlet_id_list: capitalFilterInput.outlets,
        date_start: capitalFilterInput.transactionStartDate,
        date_end: capitalFilterInput.transactionEndDate,
        page: capitalFilterInput.page,
        size: parseInt(capitalFilterInput.pageSize),
        transaction_type: capitalFilterInput.transactionType,
        sorting_field: capitalFilterInput.sortingField,
        sorting_order: capitalFilterInput.sortingOrder,
      };
      filename = "riwayat_transaksi_modal_outlet.xlsx";
      url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/outlet-capital/excel`;
    } else if (tabState === CASH_TYPE) {
      data = {
        outlet_id_list: cashFilterInput.outlets,
        date_start: cashFilterInput.transactionStartDate,
        date_end: cashFilterInput.transactionEndDate,
        page: cashFilterInput.page,
        size: parseInt(cashFilterInput.pageSize),
        transaction_type: cashFilterInput.transactionType,
        sorting_field: cashFilterInput.sortingField,
        sorting_order: cashFilterInput.sortingOrder,
      };
      filename = "riwayat_transaksi_kas_outlet.xlsx";
      url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/petty-cash/excel`;
    }

    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
          "content-type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
        "blob"
      ),
      (response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal export data menjadi excel: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getCapitalTotalSummary = () => {
    setLoading(true);
    const data = {
      query: capitalFilterInput.searchName,
      product_category: capitalFilterInput.category,
      payment_type: capitalFilterInput.paymentType,
      tenor_type: capitalFilterInput.tenorType,
      tenor: capitalFilterInput.tenor,
      outlet_id_list: capitalFilterInput.outlets,
      date_start: capitalFilterInput.transactionStartDate,
      date_end: capitalFilterInput.transactionEndDate,
      page: parseInt(capitalFilterInput.page),
      size: parseInt(capitalFilterInput.pageSize),
      transaction_type: capitalFilterInput.transactionType,
      sorting_field: capitalFilterInput.sortingField,
      sorting_order: capitalFilterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/outlet-capital/widget`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);
        setCapitalData({
          expense: `Rp ${
            CurrencyFormat(response?.data?.data?.expense) || 0
          }`,
          income: `Rp ${
            CurrencyFormat(response?.data?.data?.income) || 0
          }`,
          capital: `Rp ${CurrencyFormat(response?.data?.data?.initial_capital) || 0}`,
          totalCapital: `Rp ${
            CurrencyFormat(
              response?.data?.data?.initial_capital +
                (response?.data?.data?.income - response?.data?.data?.expense)
            ) || 0
          }`,
        });
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data total: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  useEffect(() => {
    if (tabState === CAPITAL_TYPE) {
      if (
        capitalFilterInput.transactionStartDate ||
        capitalFilterInput.transactionEndDate
      ) {
        getCapitalTransactionList();
      }
    } else {
      if (
        cashFilterInput.transactionStartDate ||
        cashFilterInput.transactionEndDate
      ) {
        getCashTransactionList();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [capitalFilterInput, cashFilterInput, tabState]);

  useEffect(() => {
    getOutlet();
    getMonthly();
  }, []);

  const getMonthly = () => {
    let startOfMonth = moment().startOf("month");
    let endOfMonth = moment();

    setCashDateValue([startOfMonth, endOfMonth]);
    setCapitalDateValue([startOfMonth, endOfMonth]);
    setCapitalFilterInput((prev) => ({
      ...prev,
      transactionStartDate: new Date(startOfMonth),
      transactionEndDate: new Date(endOfMonth),
    }));
    setCashFilterInput((prev) => ({
      ...prev,
      transactionStartDate: new Date(startOfMonth),
      transactionEndDate: new Date(endOfMonth),
    }));
  };

  return (
    <div className="px-3">
      <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
        <Title text={"Riwayat Transaksi Modal & Kas"} />
        <Breadcrumb current={"Riwayat Transaksi Modal & Kas"} />
        <div className="d-flex justify-content-end">
          <ActiveOutlets
            outletList={outletList}
            activeOutlets={
              tabState === CAPITAL_TYPE
                ? capitalOutletCheckedList
                : cashOutletCheckedList
            }
          />
        </div>
      </div>
      <Tabs defaultActiveKey="capital" onChange={handleTabChange}>
        <TabPane tab="Modal Outlet" key="capital">
          <CapitalTransaction
            capitalData={capitalData}
            handleOutletButtonClick={handleOutletButtonClick}
            handleDateChange={handleDateChange}
            handleReset={handleReset}
            loading={loading}
            data={capitalTransactionList}
            transactionTypeCount={capitalTransactionTypeCount}
            handleTransactionTypeChange={handleTransactionTypeChange}
            handleEnter={handleEnter}
            handleExport={handleExport}
            pageSizeValue={capitalPageSize}
            searchNameValue={capitalSearchName}
            tablePagination={capitalTablePagination}
            handleTableChange={handleTableChange}
            handleInputChange={handleTextInputChange}
            dateValue={capitalDateValue}
            handleDetailButtonClick={handleDetailButtonClick}
          />
        </TabPane>
        <TabPane tab="Uang Kas" key="cash">
          <CashTransaction
            handleOutletButtonClick={handleOutletButtonClick}
            handleDateChange={handleDateChange}
            handleReset={handleReset}
            loading={loading}
            data={cashTransactionList}
            transactionTypeCount={cashTransactionTypeCount}
            handleTransactionTypeChange={handleTransactionTypeChange}
            handleEnter={handleEnter}
            handleExport={handleExport}
            pageSizeValue={cashPageSize}
            tablePagination={cashTablePagination}
            handleTableChange={handleTableChange}
            handleInputChange={handleTextInputChange}
            dateValue={cashDateValue}
          />
        </TabPane>
      </Tabs>

      <ChooseOutletDialog
        title={"Pilih Cabang/Outlet"}
        visible={isOutletDialogOpen}
        handleSave={handleOutletSave}
        handleCancel={handleOutletCancel}
        data={outletList}
        onCheckAllChange={handleOutletCheckAllChange}
        onSingleChange={handleSingleOutletChange}
        indeterminate={
          tabState === CAPITAL_TYPE ? capitalIndeterminate : cashIndeterminate
        }
        outletCheckAll={
          tabState === CAPITAL_TYPE ? capitalOutletCheckAll : cashOutletCheckAll
        }
        outletCheckedList={
          tabState === CAPITAL_TYPE
            ? capitalOutletCheckedList
            : cashOutletCheckedList
        }
      />
      <DetailDialog
        setVisible={setIsDetailDialogOpen}
        visible={isDetailDialogOpen}
        handlePrint={handlePrintReceipt}
        handleCancel={handleOutletCancel}
        data={selectedTransaction}
        type="capital"
      />

      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />
    </div>
  );
};

export default CapitalCashTransaction;
